var corePageTitles = window.EDMDataStorage.corePageTitles;

$(window).on('activate.bs.scrollspy', function (ev, data) {
    if (data && data.relatedTarget) {
        var creativeId = data.relatedTarget.replace('#', '');
        var headingText = corePageTitles[creativeId] ? corePageTitles[creativeId] : corePageTitles['DEFAULT'];
        // should only exist one h1 on a page.
        var $h1Text = $('h1');
        if($h1Text.text().trim() != headingText) {
            $h1Text.text(headingText);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/interlock/core-page/dynamic-header/dynamic-header.js
// module id = 94
// module chunks = 0 1 3 6 8 11 12 14